import React from 'react';
import axios from "axios";
import { useState } from 'react';
import { Button, Form, FloatingLabel } from 'react-bootstrap';
import { Link } from 'react-router-dom';


    
    const EWayBillSoftware = () => {
        const [name, setName] = useState('')
        const [email, setEmail] = useState('')
        const [number, setNumber] = useState('')
        const [company, setCompany] = useState('')
        const [statusCode, setStatusCode] = useState('')
        const [message, setMessage] = useState('')
    
  const API_PATH = 'http://amosta.com/reactJs/EwayBillSoftware.php';
  function axios2() {

    axios({
      method: 'post',
      url: API_PATH,
      headers: {
        'content-type': 'application/json'

      },
      data: {
        "name": name,
        "email": email,
        "number": number,
        "company": company

      }
    })
      .then(result => {
        if (result.data.statusCode === 200) {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
          window.location.reload(false)
        } else {
          setStatusCode(result.data.statusCode)
          setMessage(result.data.message)
        }
        console.log(result);
      })
      .catch(error => {
        console.log(error)
      });
  }

    return (
        <div>
            <img className='img-fluid gst-software-main-banner' src="./assets/images/eway-bill-banner.jpg" alt="" />
            <div className="container gst-software-section-2">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h2 className=''>Generate E-Way Bill in a Jiffy</h2>
                        <div className="container mt-5">
                            <ul>
                                <li>100% Uptime Guaranteed</li>
                                <li>Create E-Way Bill in a Single Click</li>
                                <li>Real-time tracking of Goods in Movement</li>
                                <li>Single Click Share of Generated E-Way Bill</li>
                            </ul>

                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="container gst-software-first-form p-5 bg-white text-dark text-center border-0 rounded-2 shadow-lg w-75" style={{ marginTop: '150px' }}>
                        <h5>{statusCode}</h5>
                        <h5>{message}</h5>
                            <Form autoComplete="off">
                                <h3 className='mb-3'>Request a Call</h3>
                                <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Full Name' id='name' name="name" onChange={(e) => setName(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                    <Form.Control type='number' placeholder='Phone number' id='number' name="number" onChange={(e) => setNumber(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                    <Form.Control type='email' placeholder='name@example.com' id='email' name="email" onChange={(e) => setEmail(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='companyName' label='Company Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Company Name' id='company' name="company" onChange={(e) => setCompany(e.target.value)} required />
                                </FloatingLabel>
                                <Button type="button" onClick={axios2} className='text-center mt-3' variant='success'>Submit</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container section-3-gst-software">
                <h1>E-Way Bill Software</h1>
                <p align='justify'>E-Way Bill Software stands for Electronic Way Bill which is usually a unique bill number generated for the specific consignment involving the movement of goods exceeding INR 50,000. We provide E-Way Bill Software cloud-based application and APIs for all types of businesses catering to your specific business requirements.</p>
            </div>
            <div className="bg-light">
                <div className="container section-4-gst-software mt-5 p-5">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <img className='img-fluid' src="./assets/images/one-click.png" alt="" />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h2>One click E-Way Bills Generation for your invoices</h2>
                            <p className='mt-4' align='justify'>Our GST application enables its end users to do filing of GST returns seamlessly with GST compliances and rules. GSTRobo®-GST Application is a comprehensive solution which has various data validation checks to ensure data accuracy without any manual intervention. It allows you to create and send Digital Invoices and comes with a Light Weight Mobile Application.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container section-4-gst-software mt-5 p-5">
                <div className="row">
                    <div className="col-sm-12 col-md-4 order-md-2">
                        <img className='img-fluid' src="./assets/images/userInterface.png" alt="" />
                    </div>
                    <div className="col-sm-12 col-md-8 order-md-1">
                        <h2>User Friendly Interface</h2>
                        <p className='mt-4' align='justify'>The easy user-friendly interface of apps will let you Update Part B details, Extend Validity, initiate multi-vehicle, create consolidated E-Way Bill, Cancel E-Way Bill in case of any mistake, Create Manifest and even Update Transporter Details.</p>
                    </div>
                </div>

            </div>
            <div className="bg-light">
                <div className="container section-4-gst-software mt-5 p-5">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <img className='img-fluid' src="./assets/images/bulk-upload.png" alt="" />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h2>Bulk Upload or Integration with ERPs</h2>
                            <p className='mt-4' align='justify'>We provide Bulk Upload or Integration with ERPs for importing your invoices. Uploading data and data filling module has been specifically developed as per user's convenience and is extremely handy and fast.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container section-4-gst-software mt-5 p-5">
                <div className="row">
                    <div className="col-sm-12 col-md-4 order-md-2">
                        <img className='img-fluid' src="./assets/images/share-invoice.png" alt="" />
                    </div>
                    <div className="col-sm-12 col-md-8 order-md-1">
                        <h2>Creating & Sharing E-invoice via e-mail</h2>
                        <p className='mt-4' align='justify'>No need to generate E-Way Bill Software and E-invoice separately, Create and Share your E-invoice and E-Way Bill Software to your transporter and consignee via E-mail.</p>
                    </div>
                </div>
            </div>
            <div className="bg-light">
                <div className="container section-4-gst-software mt-5 p-5">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <img className='img-fluid' src="./assets/images/mobility.png" alt="" />
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <h2>Mobility</h2>
                            <p className='mt-4' align='justify'>Update transporter, Update Vehicle Number and Extend Validity on the go from mobile app or cloud application. Mobile apps enable Consignors, Transporters and Consignees in getting real-time updates for the movement of goods.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container section-5-gst-software mt-5 p-3 text-center">
                <h2>Key Features of E-Way Bill Software</h2>
                <div className="section-5-gst-software-cards mt-5 p-3">

                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3 w-25' src="./assets/images/auto-returns.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Easy compliance with GST and EWB Rules</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/one-click-icon.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>One click E-Way Bill Software creation</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/mobile.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Mobile App available</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/multiple-login.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>User and Sub User creation with access control</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/dashboard.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Reports/ Dashboard/ MIS</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/real-time-goods.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Real-Time updates about goods movement</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/financial.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Seamless and user-friendly system for Transporters, Consigners & Consignees</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/share-invoice-icon.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Share E-invoice and EWB with Transporter and Consignee in one Click</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/email-app-sms.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Email, App, SMS updates & notifications</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/return-filing.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>Easy GST return filing from EWB</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/uptime.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>100% uptime</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container gstrobo-section-3 bg-light mt-5 text-center pb-5">
                <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
                <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
                <div className="gstrobo-cards">
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
                        <h4 className='mt-3'>GST Software</h4>
                        <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
                        <h4 className='mt-3'>E-Way Bill Software</h4>
                        <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
                        <h4 className='mt-3'>E-Invoicing Software</h4>
                        <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
                        <h4 className='mt-3'>GST & E-Way Bill API</h4>
                        <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
                        <h4 className='mt-3'>Intelligence Insight</h4>
                        <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
                        <h4 className='mt-3'>Value Added Tools</h4>
                        <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default  EWayBillSoftware;
